import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import keys from 'ramda/src/keys';

const makeColumns = (data) => {
  const columns = keys(data[0]);
  return columns.map(item => ({
    Header: item,
    accessor: item,
    id: item,
    className: 'u-text-center',
  }));
};

const Table = ({ data, columns }) => {
  const className = `layout__item u-1/${columns}`;
  return (
    <div className={className}>
      <ReactTable
        data={data}
        showPagination={false}
        minRows={0}
        className="c-table-new c-table--small c-no-hover"
        columns={makeColumns(data)}
      />
    </div>
  );
};

Table.propTypes = {
  data: PropTypes.array.isRequired,
  columns: PropTypes.number.isRequired,
};

export default Table;
